import React, { Component } from "react";
import PropTypes from "prop-types";
import CategoryHerocontainer from "../container/CategoryHerocontainer.js";
import Searchcontainer from "../container/Searchcontainer.js";
import Headercontainer from "../container/Headercontainer.js";
import Leftnavcontainer from "../container/Leftnavcontainer.js";
import Resultslistcontainer from "../container/Resultslistcontainer.js";
import Footercontainer from "../container/Footercontainer.js";
import Helpcontainer from "../container/Helpcontainer.js";
import Scrollupcontainer from "../container/Scrollupcontainer.js";
import LegalFooter from "../container/LegalFooter.js";

class CategoriesMainComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachUrl: "",
    };
  }

  componentDidMount() {
    const hrefUrl = window.location.href;
    if (hrefUrl.indexOf("?locale.x") !== -1) {
      this.setState({
        attachUrl: hrefUrl.split("?")[1],
      });
    }
  }

  render() {
    const topicsHash = JSON.parse(this.props.topicsHash);
    const topics = JSON.parse(this.props.topics);
    const resultsInfo = JSON.parse(this.props.resultsInfo);
    const popArticlesHomeInfo = JSON.parse(this.props.popArticlesHomeInfo);
    const sections = JSON.parse(this.props.sections);
    const legalFooter = JSON.parse(this.props.legalFooter);
    const isHomeBtnEnabled = JSON.parse(this.props.isHomeBtnEnabled);
    const isPopArticleEnabled = JSON.parse(this.props.isPopArticleEnabled);
    const {
      footer,
      header,
      isLoggedIn,
      useGlobalNav,
      isNewMppEnabled,
      refID,
      locale,
      country,
      totalResultsList,
      helpContainer,
    } = this.props;

    let isLargeEnterprise = false;
    if(topics.length!==0){
      const result = topics.filter((item)=>item.ref_id === "enterprise-solutions");
      const enterpriseCategoriesLists = result.length!==0 && result[0] && result[0].categories && result[0].categories.length!==0 ?
          result[0].categories.map( item => item.ref_id) : [];
      isLargeEnterprise = refID === "enterprise-solutions" || enterpriseCategoriesLists.includes(refID)
    }
    return (
      <div className="brccategories-main-component">
        <Headercontainer
          header={header}
          country={country}
          locale={locale}
          isLoggedIn={isLoggedIn}
          useGlobalNav={useGlobalNav}
          isNewMppEnabled={isNewMppEnabled}
        />
        <CategoryHerocontainer
          topics={topics}
          country={country}
          locale={locale}
          isPopArticleEnabled={isPopArticleEnabled}
          refID={refID}
        />
        <Searchcontainer country={country} />
        <div className="flexContainer">
          <Leftnavcontainer
            sections={sections}
            refID={refID}
            attachUrl={this.state.attachUrl}
            isPopArticleEnabled={isPopArticleEnabled}
            country={country}
            isHomeBtnEnabled={isHomeBtnEnabled}
          />
          <Resultslistcontainer
            popArticlesHomeInfo={popArticlesHomeInfo}
            attachUrl={this.state.attachUrl}
            isPopArticleEnabled={isPopArticleEnabled}
            resultsInfo={resultsInfo}
            locale={locale}
            totalResultsList={totalResultsList}
            topicsHash={topicsHash}
            refID={refID}
            country={country}
          />
        </div>
        <Helpcontainer
          helpContainer={helpContainer}
          locale={locale}
          country={country}
        />
        <LegalFooter
          country={country}
          locale={locale}
          legalFooter={legalFooter}
        />
        <Footercontainer
          footer={footer}
          country={country}
          locale={locale}
          isNewMppEnabled={isNewMppEnabled}
          useGlobalNav={useGlobalNav}
        />
        <Scrollupcontainer />
      </div>
    );
  }
}

export default CategoriesMainComponent;

CategoriesMainComponent.propTypes = {
  topicsHash: PropTypes.string,
  country: PropTypes.string,
  header: PropTypes.string,
  footer: PropTypes.string,
  totalResultsList: PropTypes.number,
  topics: PropTypes.string,
  refID: PropTypes.string,
  resultsInfo: PropTypes.string,
  sections: PropTypes.string,
  isHomeBtnEnabled: PropTypes.string,
  isLoggedIn: PropTypes.string,
  useGlobalNav: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
};
